<style></style>

<template>
  <div class="component-container">
    <p class="mb-4">
      Consultants are essential to Go NAPSACC’s success. You serve as local
      ambassadors for the program, getting child care providers enrolled and
      providing ongoing support. The resources on this page support your work
      with child care providers during this entire process.
    </p>
    <how-to-row class="mb-4">
      <template #left>
        <!--<how-to-video :video="howToVideo"></how-to-video>-->
      </template>
      <template #right>
        <print-manual manualUrl="/uploads/GNS-ConsultantManual-081219.pdf">
          <template #label> Print/Download the TA Manual </template>
        </print-manual>
      </template>
    </how-to-row>

    <div class="tabs">
      <ul class="nav nav-tabs nav-justified">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" href="#modContent_0">Enrollment</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#modContent_1">Orientation</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#modContent_2">1. Assess</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#modContent_3">2. Plan</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#modContent_4">3. Take Action</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#modContent_5">4. Learn More</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#modContent_6">5. Keep it Up</a>
        </li>
      </ul>

      <div class="tab-content">
        <div class="collapse tab-pane active" :id="`modContent_0`" :class="{}" role="tabpanel">
          <enrollment-page>
            <template #support-docs>
              <span v-html="resourcePages[0]?.sections[0]?.html_content"></span>
            </template>
          </enrollment-page>
        </div> 
        <div class="collapse tab-pane" id="modContent_1" :class="{}" role="tabpanel">
          <orientation-page>
            <template #support-docs>
              <span v-html="resourcePages[1]?.sections[0]?.html_content"></span>
            </template>
          </orientation-page>
        </div>
        <div class="collapse tab-pane" id="modContent_2" :class="{}" role="tabpanel">
          <step-1-assess>
            <template #support-docs>
              <span v-html="resourcePages[2]?.sections[0]?.html_content"></span>
            </template>
          </step-1-assess>
        </div>
        <div class="collapse tab-pane" id="modContent_3" :class="{}" role="tabpanel">
          <step-2-plan>
            <template #support-docs>
              <span v-html="resourcePages[3]?.sections[0]?.html_content"></span>
            </template>
          </step-2-plan>
        </div>
        <div class="collapse tab-pane" id="modContent_4" :class="{}" role="tabpanel">
          <step-3-take-action>
            <template #support-docs>
              <span v-html="resourcePages[4]?.sections[0]?.html_content"></span>
            </template>
          </step-3-take-action>
        </div>
        <div class="collapse tab-pane" id="modContent_5" :class="{}" role="tabpanel">
          <step-4-learn-more>
            <template #support-docs>
              <span v-html="resourcePages[5]?.sections[0]?.html_content"></span>
            </template>
          </step-4-learn-more>
        </div>
        <div class="collapse tab-pane" id="modContent_6" :class="{}" role="tabpanel">
          <step5-keep-it-up>
            <template #support-docs>
              <span v-html="resourcePages[6]?.sections[0]?.html_content"></span>
            </template>
          </step5-keep-it-up>
        </div>
      </div>
    </div>
    
    <!-- <button
      v-if="moreTabs"
      @click="goToNextTab()"
      class="btn btn-orange-blue float-right block mt-4"
    >
      Next Section
    </button> -->
  </div>
</template>

<script>
import OrientationPage from "./pages/OrientationPage";
import Step1Assess from "./pages/Step1Assess";
import Step2Plan from "./pages/Step2Plan";
import Step3TakeAction from "./pages/Step3TakeAction";
import Step4LearnMore from "./pages/Step4LearnMore";
import EnrollmentPage from "./pages/EnrollmentPage";
import Step5KeepItUp from "./pages/Step5KeepItUp";
import VideoModal from "../materials/VideoModal";
import PrintManual from "../PrintManual.vue";
import HowToRow from "../HowToRow.vue";

export default {
  components: {
    EnrollmentPage,
    OrientationPage,
    Step1Assess,
    Step2Plan,
    Step3TakeAction,
    Step4LearnMore,
    Step5KeepItUp,
    VideoModal,
    PrintManual,
    HowToRow
  },
  data() {
    return {
      currentTab: 0,
      videoInfo: null,
      showModalInfoVideo: false,
      howToVideo: {
        title: "Watch the Consultant Resources Video",
        url: "https://www.youtube.com/embed/OaLpKOVvMe8?ecver=2&modestbranding=1&autoplay=0&showinfo=0&enablejsapi=1&rel=0",
      },
      moreTabs: true,
      resourcePages: [],
    };
  },
  watch: {
    currentTab: function () {
      this.moreTabs = this.hasMoreTabs();
    },
  },
  methods: {
    showVideoModal(videoInfo) {
      if (videoInfo && videoInfo.title) {
        this.videoInfo = null;
        this.$nextTick(() => {
          this.videoInfo = videoInfo;
          this.$nextTick(() => {
            this.showModalInfoVideo = true;
          });
        });
      }
    },
    hasMoreTabs() {
      // console.log("check resourcesTabs");
      if (this.$refs.resourcesTabs) {
        return this.currentTab < this.$refs.resourcesTabs.tabs.length - 1;
      }
      return true;
    },
    goToNextTab() {
      if (!this.hasMoreTabs()) {
        return;
      }
      this.currentTab++;
    },
    setPageSections(pages) {
      axios.get('/ta-resources/sections', {
        params: {
          page_id: pages
        }
      }).then((response) => {
        this.resourcePages = response.data;
      })
    }
  },
  mounted() {
    this.setPageSections([1,2,3,4,5,6,7]);
  }
};
</script>
